
















































































import {
  QueryWorkOrdersRequest,
  UserCustomWorkorderFilter,
  UsersApi,
  User as PerformoUser,
  ValidationProblemDetails
} from 'performo-api';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: mapGetters({
    usersApi: 'usersApi',
    performoUser: 'performoUser',
    currentPropertyId: 'currentPropertyId'
  })
})
export default class CreateCustomFilterComponent extends Vue {
  @Prop({ required: true })
  private filterQuery!: QueryWorkOrdersRequest;

  private usersApi!: UsersApi;
  private performoUser!: PerformoUser;
  private customFilter: UserCustomWorkorderFilter = {};
  private currentPropertyId!: string;
  private showDialog = false;
  private loading = false;
  private successConfirmation = false;
  private problems: ValidationProblemDetails = [];
  private pickedColor!: string;
  private greenSwatchColor = '#69a348';
  private orangeSwatchColor = '#f46601';
  private pinkSwatchColor = '#fe5d5d';
  private blueSwatchColor = '#5d85ae';
  private turquoiseSwatchColor = '#5cad8f';

  data() {
    return {
      order: undefined,
      newAssignTo: undefined,
      pickedColor: undefined
    };
  }

  private swatches = [
    [this.greenSwatchColor],
    [this.orangeSwatchColor],
    [this.pinkSwatchColor],
    [this.blueSwatchColor],
    [this.turquoiseSwatchColor]
  ];

  private mounted() {
    this.pickedColor = this.greenSwatchColor;
    this.filterQueryChanged();
  }

  @Watch('filterQuery')
  private filterQueryChanged() {
    this.customFilter.query = this.filterQuery;

    // this.filterQuery is of type QueryWorkOrdersRequest, which is created during code generation from a GET([FromQuery] WorkorderQuery) controller action.
    // When trying to map to this.customFilter.query<WorkorderQuery>, the number values are being implicitly cast as strings
    // The saveCustomFilter() controller action is a PUT([FromBody]) method that throws JSON serializing errors when receiving strings that are expected to be numbers
    // The code below handles this special case by explictitly casting to valid numbers, or removing them from the query otherwise
    if (
      this.customFilter.query.skip != null &&
      this.customFilter.query.skip.toString() !== '' &&
      !isNaN(Number(this.customFilter.query.skip.toString()))
    ) {
      this.customFilter.query.skip = Number(this.customFilter.query.skip);
    } else {
      delete this.customFilter.query.skip;
    }

    if (
      this.customFilter.query.take != null &&
      this.customFilter.query.take.toString() !== '' &&
      !isNaN(Number(this.customFilter.query.take.toString()))
    ) {
      this.customFilter.query.take = Number(this.customFilter.query.take);
    } else {
      delete this.customFilter.query.take;
    }

    if (
      this.customFilter.query.jobPriority != null &&
      this.customFilter.query.jobPriority.toString() !== '' &&
      !isNaN(Number(this.customFilter.query.jobPriority.toString()))
    ) {
      this.customFilter.query.jobPriority = Number(
        this.customFilter.query.jobPriority
      );
    } else {
      delete this.customFilter.query.jobPriority;
    }
  }

  @Watch('currentPropertyId')
  private propertyIdChanged() {
    this.closeDialog();
  }

  private async handleSaveCustomFilter() {
    try {
      this.loading = true;
      const userSavedFilter = await this.usersApi.saveCustomFilter({
        saveUserCustomFilterCommand: {
          userId: this.$store.state.performoUser.userId,
          customFilter: this.customFilter
        }
      });
      this.$store.commit('setPerformoUser', userSavedFilter);
      this.loading = false;
      this.successConfirmation = true;
    } catch (error) {
      this.editorError(error as ValidationProblemDetails);
    }
  }

  @Watch('pickedColor')
  private colorPicked() {
    if (this.pickedColor) {
      this.customFilter.buttonColor = this.pickedColor;
    }
  }

  private closeDialog() {
    this.showDialog = false;
    this.successConfirmation = false;
    this.customFilter.title = '';
    this.pickedColor = this.greenSwatchColor;
  }

  private async editorError(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    let vpd: ValidationProblemDetails;
    if (error instanceof Response) {
      vpd = await error.json();
    } else {
      vpd = error;
    }
    this.problems = vpd;
  }
}
